if (window.location.pathname.includes("settings/ip_logging")) {
  var options = {
    columnDefs: [
      { targets: [0], className: 'text-left more-padding' },
      {
        targets: [1],
        className: 'text-left more-padding',
        render: function (data, type, row) {
          if (row.ip_addresses.length === 1) {
            return row.ip_addresses[0].ip;
          }

          let string = '<ul class="text-left mb-0 pl-3">';
          for (let i = 0; i < row.ip_addresses.length; i++) {
            string += `<li>${row.ip_addresses[i].ip}</li>`
          }
          string += '</ul>'

          return string;
        }
      },
      { targets: [2], width: '120px' }
    ]
  };

  $.each($(".data-table"), function() {
      $(this).data("options", options);
  });

  $(window).on('dt-add-opened', function () {
    window.app_data.ip_addresses = [''];
  });

  $(window).on("/api/settings/ip_logging/get.fetched", function (e, response) {
    window.app_data.ip_addresses = response.ip_logging.ip_addresses.map(item => item.ip);
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/ip_logging.js